import { useRef, useState, useEffect } from "react";
import { Typography, TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { formatDate } from "../../../helper/converters";

const DateTimePicker = (props: any) => {
  const { date, onChange } = props;
  const [value, setValue] = useState<Date | null>(
    date ? new Date(date) : new Date()
  );

  const refDate = useRef<any>(null);

  useEffect(() => {
    if (date) {
      setValue(new Date(date));
    }
  }, [date]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        ref={refDate}
        value={value}
        onChange={(e) => {
          setValue(e);
          onChange(e);
        }}
        renderInput={(params) => (
          <TextField
            className="date-picker"
            sx={{ width: 0, height: 0, visibility: "hidden" }}
            {...params}
          />
        )}
      />
      <Typography
        variant="h2"
        component="h2"
        onClick={() => {
          if (refDate && refDate.current) {
            refDate.current.querySelector("button").click();
          }
        }}
      >
        {formatDate(value)}
      </Typography>
    </LocalizationProvider>
  );
};

export default DateTimePicker;
